import React from "react";
import styled from "styled-components";

const Container = styled.div`
display:flex;
margin-top: 6px;
`
const Input = styled.input`
margin: 8px 8px 0px 0px;
padding: 8px;
background-color: "#8289a6";
min-width: 20px;
min-height: 20px;
accent-color: #8289a6;
&:checked {
    background: gray
}`

const Label = styled.label`
    color: var(--Text700);
    font-size: 16px;
    opacity: 0.8;
    margin-top: 6px;
`

const CheckBox = ({ onChange,...props}) => {
    return(
        <Container>
            <Input
                type="checkbox"
                name={props.name}
                checked={props.value}
                onChange={(e) => onChange(e.target.checked)}
            />
            <Label>{props.msgTxt}</Label>
        </Container>
    )
}

export default CheckBox;